import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { AP3UserManagementRouteNames, AP3UserManagementRoutePathNames } from '../../enums';

const Component = () => import('../content/Content.vue');

export default {
  path: buildChildURL(AP3UserManagementRoutePathNames.CREATE),
  name: AP3UserManagementRouteNames.AP3_USERS_CREATE,
  component: Component,
} as RouteRecordRaw;
